import { useGtm as useVueGtm } from '@gtm-support/vue-gtm'

export function useGtm() {
  // Safely access GTM instance
  const gtm = useVueGtm()

  // Return null if GTM is not available
  if (!gtm) {
    return null
  }

  return {
    /**
     * Track a custom event to GTM
     */
    trackEvent(event: Record<string, any>) {
      gtm.trackEvent(event)
    },

    /**
     * Track a page view to GTM
     */
    trackView(
      screenName: string,
      path: string,
      additionalParams?: Record<string, any>,
    ) {
      gtm.trackView(screenName, path, additionalParams)
    },

    /**
     * Access the raw GTM instance
     */
    instance: gtm,
  }
}
